import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { LibraryRootState, LibraryDispatch } from "./store";

// Typed hooks for the library Redux store
export const useLibraryDispatch: () => LibraryDispatch = useDispatch;
export const useLibrarySelector: TypedUseSelectorHook<LibraryRootState> = useSelector;

// Legacy hooks for backward compatibility (will be deprecated)
export const useAppDispatch: () => LibraryDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<LibraryRootState> = useSelector;